import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";
import MatchDots from "../../components/ExcerciseTypes/LineTo/MatchDots";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";

const json = {
  2: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    // audio: "Audios/bt_fpt_ai/p24_intro.mp3",
    // autoPlay: true,
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page25/Key/E2answerKey.png",
    component: T6,
    isHiddenCheck: true,
    // hideBtnFooter:true,
    maxLength: 10,
    stylesTextInput: {
      borderBottom: "3px dotted black",
      maxLength: 4,
      textAlign: "center",
      background: "none",
      fontSize: 24,
      textTransform: "uppercase",
    },

    inputSize: 80,
    titleQuestion: [
      {
        num: "",
        title: `
		    `,
        color: "rgb(99,197,244)",
      },
    ],
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        Các em quan sát hình rồi điền câu trả lời vào chỗ chấm.
        <video src="Audios/bt_fpt_ai/guide/p25_e2.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        <div style='position: relative; line-height: 40px'>
         <img src='/img/FriendsPlus/Page25/E2/1.jpg' style='height:9cm; width: 24cm; margin-top: -35px'/><br>
        <div style='margin-top: 30px'>
					<div><b>a) Quan sát tranh rồi viết số đo các góc sau:</b></div>
        	<span style=''>Góc đỉnh N; cạnh NM, NH bằng <input id= "0"><sup>o</sup></span><br>
					<span style=''>Góc đỉnh H; cạnh HM, HN bằng <input id= "1"><sup>o</sup></span><br>
					<span style=''>Góc đỉnh C; cạnh CA, CB bằng <input id= "2"><sup>o</sup></span><br>
					<span style=''>Góc đỉnh D; cạnh DA, DB bằng <input id= "3"><sup>o</sup></span><br>
        </div>
        <div style='position:absolute;top:-30px;left:0px;font-size:30px;color:rgb(99,197,244)'><b>2</b></div>
        <div style='margin-top: 50px'>
					<div><b>b) Viết tiếp vào chỗ chấm cho thích hợp.</b></div>
        	<span style=''>Trong các góc ở câu a, góc có số đo bé nhất là:<br>
					Góc đỉnh: <input id= "4" width= "100px">, cạnh <input id= "5" width= "100px">,  <input id= "5" width= "100px">.</span>
        </div>
        </div>
        `,
        answer: ["45", "90", "36", "52", "C", "CA", "CB"],
      },
    ],
  },
  1: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    // audio: "Audios/bt_fpt_ai/p24_intro.mp3",
    // autoPlay: true,
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page25/Key/E1answerKey.png",
    component: T6,
    isHiddenCheck: true,
    // hideBtnFooter:true,
    maxLength: 10,
    stylesTextInput: {
      borderBottom: "3px dotted black",
      maxLength: 4,
      textAlign: "center",
      background: "none",
      fontSize: 24,
      textTransform: "uppercase",
    },
    inputSize: 80,
    titleQuestion: [
      {
        num: "1",
        title: `Viết số đo góc vào ô trống.
		    `,
        color: "rgb(99,197,244)",
      },
    ],
  
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        Các em quan sát hình rồi điền câu trả lời vào chỗ chấm.
        <video src="Audios/bt_fpt_ai/guide/p25_e2.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],

    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
				<img src='/img/FriendsPlus/Page25/E1/2.jpg' style='height:8cm; width: 13cm'/>
        <div style='position: relative; line-height: 40px'>
        <img src='/img/FriendsPlus/Page25/E1/1.jpg' style='height:8cm; width: 21cm'/>
				<div style='position: absolute; top: 76px; left: 100px; display: flex; flex-direction: column; line-height: 45px'>
        	<span style=''>Góc đỉnh A; cạnh AB; AD</span>
					<span style=''>Góc đỉnh B; cạnh BA; BC</span>
					<span style=''>Góc đỉnh C; cạnh CB; CD</span>
					<span style=''>Góc đỉnh D; cạnh DA; DC</span>
        </div>
        <div style='position: absolute; top: 76px; left: 563px; display: flex; flex-direction: column; line-height: 45px'>
        	<span style=''><input id= "0"><sup>o</sup></span>
					<span style=''><input id= "1"><sup>o</sup></span>
					<span style=''><input id= "2"><sup>o</sup></span>
					<span style=''><input id= "3"><sup>o</sup></span>
        </div>
        </div>
        `,
        answer: ["120", "90", "90", "60"],
      },
    ],
  },
};

export default json;
